import { HttpClient } from '../common/httpClient';
import { AxiosHttpClient } from '../common/axiosHttpClient';
import { appConfig } from '../../config';

export class AuthenticationLegacyApi {
  private readonly httpClient: HttpClient;

  constructor() {
    this.httpClient = new AxiosHttpClient({
      baseUrl: appConfig.URL_API,
      accessToken: () => localStorage.getItem('token')!,
    });
  }

  async requestNew2faCode(username: string, password: string): Promise<{ '2fa': string }> {
    return this.httpClient.post('/authentication', { email: username, password });
  }
}